Ext.define('SA.data.CustomLocations', {
    extend: 'SA.data.List',
    singleton: true,

    ComboItemKeys: ['type', 'id', 'name', 'locationSeries', 'lastUsed', 'censusRelease'],
    RadiusItemKeys: ['type', 'id', 'name', 'locationSeries', 'lastUsed', 'geographicUnit', 'radius', 'unit'],

    indexField: 'id',

    appendSeries(combo, locationSeries) {
        var currentSeries = combo.locationSeries;

        if (currentSeries.includes(locationSeries)) {
            return;
        }

        currentSeries.push(locationSeries);

        this.updateCombo(combo);
    },

    get(id) {
        if (Array.isArray(id)) {
            return this.callParent([id]);
        }

        if (Ext.isObject(id)) {
            switch (id.type) {
                case 'radius':
                case 'combination':
                    return id;
            }
        }

        if (Number.isInteger(id)) {
            return this.callParent([id]);
        }
        else if (SA.model.CustomLocationStringId.match(id)) {
            return this.callParent([SA.model.CustomLocationStringId.getInteger(id)]);
        }
        else if (Ext.isObject(id) && Number.isInteger(id.id)) {
            return this.callParent([id.id]);
        }
    },

    getAllCombinations() {
        return this.getAll().filter(item => item.type === 'combination');
    },

    getAllSeries() {
        return this.items.map(item => item.locationSeries).flat();
    },

    getChangeListener(callback) {
        return SA.ListenerFactory.create(this, 'change', callback);
    },

    getSeries(id) {
        return this.get(id).locationSeries;
    },

    isComboId(id) {
        return this.get(id)?.type === 'combination';
    },

    isRadiusId(id) {
        return this.get(id)?.type === 'radius';
    },

    loadAll() {
        return SA.Ajax.request({resource: 'user/customLocations'})
            .then(locations => {
                locations.forEach(this.add, this);

                return locations;
            });
    },

    async remove(id) {
        var item = this.get(id),
            projects = SA.data.Projects.all.filter(project => project.containsLocation(id));

        await Promise.all([
            ...projects.map(project => {
                project.removeLocation(id);

                return project.queueSave();
            }),

            SA.data.FavoriteLocations.remove(id),
            SA.data.RecentLocations.remove(id),
            this.superclass.remove.call(this, item)
        ]);

        await SA.Ajax.request({
            method: 'delete',
            resource: 'user/customLocations',

            data: [item.id]
        });
    },

    updateCombo(combo, callback) {
        SA.Ajax.request({
            method: 'update',
            resource: 'user/customLocations',

            data: [{
                id: combo.id,
                locationSeries: combo.locationSeries,
                name: combo.name,
                type: 'combination'
            }],

            success(locations) {
                var combo = locations[0];

                Ext.callback(callback, null, [combo]);
            }
        });

        this.fireEvent('update:locationItem', combo);
        this.fireEvent('change');
    }
});